import React from 'react';
import * as Types from './types';

export const getInteractionClass = ({
    error,
    active,
    touched,
    disabled,
    readOnly,
    submitting
}: Types.IGetInteractionClassesArguments): string => {
    if (submitting || disabled || readOnly) {
        return 'disabled';
    }

    if (active) {
        return 'focus';
    }

    if (!touched) {
        return '';
    }

    return error ? 'invalid' : 'valid';
};

export const preventDefault = (event: React.SyntheticEvent): void => event.preventDefault();
